const debounce = (callback, delay) => {
  return (...args) => {
    if (this.currentTimer) clearTimeout(this.currentTimer);
    this.currentTimer = setTimeout(() => callback(...args), delay);
    return this.currentTimer
  }
}

export default debounce;


// WEBPACK FOOTER //
// ./src/helpers/debounce.js